const emptyHandler = () => {};

export const postFetch = ({
  url,
  data,
  onSuccess,
  onFailure,
  method = "POST",
}) => {
  onSuccess = onSuccess || emptyHandler;
  onFailure = onFailure || emptyHandler;
  return fetch(url, {
    method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => {
      response.json().then((data) => {
        if (response.ok) {
          onSuccess(data);
        } else {
          onFailure(data);
        }
      });
    })
    .catch((err) => onFailure(err));
};

export const prefixProtocol = (host) => {
  if (host.startsWith("http")) {
    return host;
  }
  const protocol = host.endsWith(".com") ? "https://" : "http://";
  return `${protocol}${host}`;
};

export const isIP = (hostname) => {
  if (hostname === "localhost") {
    return true;
  }
  const IPRegex = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;

  try {
    return !!hostname.match(IPRegex)[0];
  } catch (e) {
    return false;
  }
};

export function BSCard(props) {
  const {
    widthOffset,
    id,
    extraBodyClass = "",
    title,
    extraBodyStyle,
    form,
    body,
    button,
    footer,
    subtitle,
  } = props;

  return (
    <div className={widthOffset} id={id || ""}>
      <div className="card shadow p-3 mb-5 bg-white rounded border-0">
        <div className="card-header pb-2 border-0 text-dark bg-white">
          <h5 className="card-title float-left">{title}</h5>
          {button}
        </div>
        <div className="card-header pt-0 border-0 text-dark bg-white">
          <h6 className="card-title text-muted">{subtitle}</h6>
        </div>
        <div className={`card-body ${extraBodyClass}`} style={extraBodyStyle}>
          {form}
          {body}
        </div>
        {footer ? <div className="card-footer">{footer}</div> : null}
      </div>
    </div>
  );
}
